import { z } from 'zod';

export const autoLockerNotificationSchema = z.object({
  imageUrl: z.string(),
  packageId: z.string(),
  expiredTime: z.number(),
});

export type AutoLockerNotificationType = z.infer<
  typeof autoLockerNotificationSchema
>;
